import { Chip, Tooltip } from '@mui/material';
import { styled } from '@mui/styles';
import React from 'react';

import WsColors from '../../WsColors';

export enum WsChipVariants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  SUCCESS = 'success',
  INVALID = 'invalid',
  UNKNOWN = 'unknown',
  QUATERNARY = 'quaternary',
  STAGE = 'stage',
  STATUS = 'status',
}

export enum WsChipSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
const mapChipSize = new Map();
mapChipSize.set('small', '12px');
mapChipSize.set('medium', '14px');
mapChipSize.set('large', '16px');

const mapBgColor = new Map();
mapBgColor.set('primary', WsColors.TheBlues50);
mapBgColor.set('secondary', WsColors.Green100);
mapBgColor.set('tertiary', WsColors.Yellow100);
mapBgColor.set('success', WsColors.Green100);
mapBgColor.set('invalid', WsColors.Red100);
mapBgColor.set('unknown', WsColors.TertiaryShades50);
mapBgColor.set('stage', WsColors.TheBlues50);
mapBgColor.set('status', WsColors.YellowBg);

const mapColor = new Map();
mapColor.set('primary', WsColors.TheBlues500);
mapColor.set('secondary', WsColors.TertiaryShades800);
mapColor.set('tertiary', WsColors.TertiaryShades800);
mapColor.set('success', WsColors.Green500);
mapColor.set('invalid', WsColors.Red500);
mapColor.set('unknown', WsColors.TertiaryShades500);
mapColor.set('stage', WsColors.TheBlues700);
mapColor.set('status', WsColors.Yellow700);

export type ChipPropsType = {
  value?: string;
  ChipSize?: WsChipSize;
  isPointer?: boolean;
  borderColor?: string;
};

export const StyledChip = styled(Chip)(
  ({ value, ChipSize, isPointer, borderColor }: ChipPropsType) => ({
    color: mapColor.get(value),
    borderRadius: 4,
    fontSize: mapChipSize.get(ChipSize),
    marginRight: 5,
    background: mapBgColor.get(value),
    fontWeight: 700,
    ...(isPointer && { cursor: 'pointer' }),
    ...(borderColor && { border: `1px solid ${borderColor}` }),
  })
);
export interface IWsChip {
  value: string;
  icon?: React.ReactElement;
  variant: WsChipVariants;
  size?: WsChipSize;
  isPointer?: boolean;
  tooltipText?: string;
  borderColor?: string;
}
const WsChip = ({
  value,
  icon,
  variant,
  size = WsChipSize.MEDIUM,
  isPointer,
  tooltipText,
  borderColor,
}: IWsChip) => (
  <div>
    {tooltipText ? (
      <Tooltip title={tooltipText}>
        <StyledChip
          icon={icon}
          label={value}
          value={variant}
          ChipSize={size}
          isPointer={isPointer}
          borderColor={borderColor}
        />
      </Tooltip>
    ) : (
      <StyledChip
        icon={icon}
        label={value}
        value={variant}
        ChipSize={size}
        isPointer={isPointer}
        borderColor={borderColor}
      />
    )}
  </div>
);

export default WsChip;
